<script>
export default {
  name: 'Login',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    overlayClose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      code: null,
      tel: null,
      checkCodeKeyId: null,
      sendFlag: false,
      gap: 60
    };
  },
  watch: {
    value: {
      handler() {
        this.visible = this.value;
      },
      immediate: true
    }
  },
  beforeDestroy() {
    clearInterval(this.sendTimer);
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('input', false);
    },
    inputCode(val) {
      this.code = val;
    },
    inputTel(val) {
      this.tel = val;
    },
    sendCode() {
      if (this.sendFlag) return;
      this.sendTimer = setInterval(() => {
        this.gap -= 1;
        if (!this.gap) {
          clearInterval(this.sendTimer);
          this.sendFlag = false;
          this.gap = 60;
        }
      }, 1000);
      this.sendFlag = true;

      $$.module.core.$api.sendSms({
        data: {
          mobile: this.tel
        },
        success: (res) => {
          this.$toast('验证码发送成功');
          this.checkCodeKeyId = res;
        }
      });
    },
    submit() {
      if (!this.tel) {
        this.$toast('请填写手机号');
        return;
      }
      if (!this.code) {
        this.$toast('请填写短信验证码');
        return;
      }

      if (!this.checkCodeKeyId) {
        this.$toast('验证码错误');
        return;
      }

      $$.module.core.$api.login({
        data: {
          mobile: this.tel,
          checkCode: this.code,
          checkCodeKeyId: this.checkCodeKeyId
        },
        success: (res) => {
          this.$emit('success', {
            phone: this.tel,
            token: res.token
          });
          this.close();
          this.$toast('登陆成功');
        }
      });
    }
  },
  render() {
    const props = {
      props: {
        value: this.visible,
        'get-container': 'body'
      },
      on: {
        // 'click-overlay': this.close,
        'close-on-click-overlay': false
      }
    };
    if (this.overlayClose) {
      props.on['click-overlay'] = this.close;
    }
    return (
      <van-action-sheet {...props}>
        <div class="content">
          <div class="title">登陆</div>
          <van-field class="item-input" value={this.tel} border={false} {...{ on: { input: this.inputTel } }} placeholder="手机号" />
          <van-field class="item-input item-code" value={this.code} border={false} {...{ on: { input: this.inputCode } }} placeholder="短信验证码">
            <div class="right-icon" slot="right-icon">
              {this.sendFlag ? (
                <span class="disabled">{this.gap}s</span>
              ) : (
                <span class="active" onclick={this.sendCode}>
                  获取验证码
                </span>
              )}
            </div>
          </van-field>
          <van-button class="item-button" onclick={this.submit} type="info">
            提交
          </van-button>
        </div>
      </van-action-sheet>
    );
  }
};
</script>
<style lang="less" scoped>
div {
  box-sizing: border-box;
}
.disabled {
  color: rgba(204, 204, 204, 1);
}

.content {
  padding: 25px 40px 38px;
  width: 100%;
  .avator-wrap {
    text-align: center;
  }
  .title {
    text-align: center;
    width: 100%;
    height: 36px;
    font-size: 16px;
    font-weight: 600;
    color: rgba(32, 34, 36, 1);
    line-height: 36px;
    margin-top: 11px;
  }
  .tip {
    text-align: center;

    height: 36px;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: rgba(146, 146, 146, 1);
    line-height: 36px;
  }
  .item-input {
    width: 100%;
    height: 42px;
    border-radius: 21px;
    border: 0.5px solid rgba(204, 204, 204, 0.5);
    margin-top: 10px;
  }
  .item-name {
    margin-top: 14px;
  }
  .item-code {
    .right-icon {
      color: rgba(0, 148, 247, 1);
    }
  }
  .item-button {
    margin-top: 36px;
    width: 100%;
    height: 39px;
    border-radius: 19px;
    background: linear-gradient(270deg, rgba(0, 198, 252, 1) 0%, rgba(0, 148, 247, 1) 100%);
    border: 0;
  }
}
</style>
